import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { Layout } from '../../components';

import styles from './Legal.module.css';

const options = {
    renderNode: {
        [BLOCKS.HEADING_1]: (_, children) => (
            <h2>
                { children }
            </h2>
        ),
        [BLOCKS.HEADING_2]: (_, children) => (
            <h3>
                { children }
            </h3>
        ),
    },
};

export const Legal = ({
    title,
    seoData,
    content,
    location,
    className,
}) => {
    const mainClasses = classNames(styles.main, className);

    return (
        <Layout
            seoData={ seoData }
            location={ location }
            className={ mainClasses }>
            <h1 className={ styles.title }>
                { title }
            </h1>
            <section className={ styles.content }>
                { documentToReactComponents(content, options) }
            </section>
        </Layout>
    );
};

Legal.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    seoData: PropTypes.shape({
        path: PropTypes.string,
        article: PropTypes.bool,
        image: PropTypes.string,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
    }),
};

export default Legal;
